import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useCurrentBreakpoint = () => {
  const theme = useTheme();

  // Using useMediaQuery to determine which breakpoint is active
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.only('xl'));

  // Get the current breakpoint
  const currentBreakpoint = () => {
    if (isXs) return 'xs';
    if (isSm) return 'sm';
    if (isMd) return 'md';
    if (isLg) return 'lg';
    if (isXl) return 'xl';
    return 'unknown';
  };

  // Get the pixel value for the current breakpoint
  const currentBreakpointValue =
    currentBreakpoint() !== 'unknown'
      ? theme.breakpoints.values[
          currentBreakpoint() as keyof typeof theme.breakpoints.values
        ]
      : undefined;

  return {
    breakpoint: currentBreakpoint(),
    pixelValue: currentBreakpointValue,
  };
};
